@if (keyTechnologiesImage()) {
  <div class="tw-block tw-my-5">
    <img [src]="keyTechnologiesImage()"
         alt="key technologies"
         class="tw-w-full tw-h-auto" />
  </div>
}
